(() => {
  'use strict';
  if (window.AWSupplierRoutingP2?.version) return;

  const VERSION = '1.1.0';
  const CONFIG_SELECTOR = '[data-aw-supplier-routing-p2]';

  const parseConfig = () => {
    const node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try {
      const data = JSON.parse(node.textContent || '{}');
      const canonicalProductId = String(data.canonicalProductId || '');
      const routes = Array.isArray(data.routes) ? data.routes : [];
      data.routes = routes.map((route) => {
        const canonicalVariantId = String(route?.canonicalVariantId || '');
        const declaredTargetVariantId = String(route?.targetVariantId || '');
        const declaredTargetProductId = String(route?.targetProductId || '');
        const canonicalOnly = Boolean(
          canonicalVariantId
          && declaredTargetVariantId === canonicalVariantId
          && declaredTargetProductId === canonicalProductId
        );
        return {
          ...route,
          canonicalVariantId,
          targetVariantId: canonicalVariantId,
          targetProductId: canonicalProductId,
          available: Boolean(route?.available && canonicalOnly),
          routed: Boolean(route?.routed && route?.available && canonicalOnly)
        };
      });
      data.byVariant = new Map(data.routes.map((route) => [route.canonicalVariantId, route]));
      return data;
    } catch (_) {
      return null;
    }
  };

  const config = parseConfig();
  if (!config) return;

  const hidden = (form, name, value) => {
    let input = [...form.querySelectorAll('input[type="hidden"]')].find(
      (node) => node.name === name && node.dataset.awSupplierRoutingP2 === 'true'
    );
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.awSupplierRoutingP2 = 'true';
      form.appendChild(input);
    }
    input.value = String(value ?? '');
    return input;
  };

  const removeRouteProperties = (form) => {
    form.querySelectorAll('input[data-aw-supplier-routing-property="true"]').forEach((node) => node.remove());
  };

  const addRouteProperty = (form, key, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${key}]`;
    input.value = String(value ?? '');
    input.dataset.awSupplierRoutingProperty = 'true';
    form.appendChild(input);
  };

  const canonicalControl = (form) =>
    form.querySelector('[data-aw-canonical-variant-control="true"]')
    || form.querySelector('[data-variant-select]');

  const canonicalVariantId = (form) => String(canonicalControl(form)?.value || '');

  const buttonsFor = (form) => {
    const nodes = [...form.querySelectorAll('[data-add-button],button[type="submit"][name="add"]')];
    if (form.id) {
      document.querySelectorAll(`button[form="${CSS.escape(form.id)}"]`).forEach((node) => nodes.push(node));
    }
    return [...new Set(nodes)];
  };

  const setButtonState = (form, available) => {
    buttonsFor(form).forEach((button) => {
      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
      const label = button.querySelector('[data-add-label],[data-add-to-cart-text]');
      if (label) label.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      else if (button.matches('[data-add-button]')) button.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    });
  };

  const syncOptions = (form) => {
    const select = form.querySelector('[data-variant-select]');
    if (!select) return;
    select.querySelectorAll('option').forEach((option) => {
      const route = config.byVariant.get(String(option.value || ''));
      if (route?.available) option.disabled = false;
    });
  };

  const paintAvailability = (form, route) => {
    const scope = form.closest('.product-info') || document;
    const available = Boolean(route?.available);
    const commerce = scope.querySelector('[data-aw-availability]');
    if (commerce) {
      commerce.textContent = available ? 'Disponible' : 'Indisponible';
      commerce.classList.toggle('is-unavailable', !available);
    }
    const block = scope.querySelector('[data-aw-public-logistics]');
    if (block) {
      block.dataset.awLogisticsState = route?.state || (available ? 'available' : 'unavailable');
      block.dataset.awLogisticsBackorder = route?.backorder ? 'true' : 'false';
      const label = block.querySelector('strong');
      const delay = block.querySelector('small');
      if (label) label.textContent = available ? 'Disponible' : 'Indisponible';
      if (delay) {
        delay.textContent = route?.delay ? `Délai estimé : ${route.delay}` : '';
        delay.hidden = !route?.delay;
      }
    }
    const delayNode = scope.querySelector('[data-aw-logistics-delay]');
    if (delayNode) {
      delayNode.textContent = route?.delay ? `Délai estimé : ${route.delay}` : '';
      delayNode.hidden = !route?.delay;
    }
    setButtonState(form, available);
  };

  const sync = (form) => {
    if (!form) return;
    const id = canonicalVariantId(form);
    const route = config.byVariant.get(id);
    hidden(form, 'id', id);
    removeRouteProperties(form);

    if (route?.available && route?.routed) {
      addRouteProperty(form, '_AW Canonical Product ID', config.canonicalProductId);
      addRouteProperty(form, '_AW Canonical Variant ID', id);
      addRouteProperty(form, '_AW Canonical Title', config.canonicalTitle);
      addRouteProperty(form, '_AW Canonical URL', config.canonicalUrl);
      addRouteProperty(form, '_AW Canonical Variant Title', route.canonicalVariantTitle || '');
      addRouteProperty(form, '_AW Routing P2', '1');
    }

    form.dataset.awSupplierRoute = route?.routed ? 'routed' : 'canonical';
    form.dataset.awSupplierRouteAvailable = route?.available ? 'true' : 'false';
    paintAvailability(form, route || { available: false });

    try {
      document.dispatchEvent(new CustomEvent('aw:supplier-route-updated', {
        detail: {
          canonicalVariantId: id,
          routed: Boolean(route?.routed),
          available: Boolean(route?.available)
        }
      }));
    } catch (_) {}
  };

  const install = (scope = document) => {
    const forms = [];
    if (scope.matches?.('form.aw-pdp-buy-form')) forms.push(scope);
    scope.querySelectorAll?.('form.aw-pdp-buy-form').forEach((form) => forms.push(form));

    forms.forEach((form) => {
      if (form.dataset.awSupplierRoutingInstalled === 'true') {
        syncOptions(form);
        sync(form);
        return;
      }
      const control = form.querySelector('[data-variant-select]') || form.querySelector('[name="id"]');
      if (!control) return;
      control.dataset.awCanonicalVariantControl = 'true';
      if (control.name === 'id') {
        control.dataset.awOriginalName = 'id';
        control.removeAttribute('name');
      }
      form.dataset.awSupplierRoutingInstalled = 'true';
      syncOptions(form);
      control.addEventListener('change', () => queueMicrotask(() => sync(form)));
      sync(form);
    });
  };

  const boot = () => install(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => install(event.target));

  window.AWSupplierRoutingP2 = {
    version: VERSION,
    install,
    sync,
    getConfig: () => config,
    policy: 'formal-routing-state-only;explicit-identity-only;freshness-24h;canonical-variant-only;fail-closed;no-public-supplier'
  };
})();
